import { KYMW1107Model } from './../kymw1107.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品媒体別文字情報取得クラス
 *
 * @export GetGoodsNutrientComponentListService
 * @class GetGoodsNutrientComponentListService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetGoodsNutrientComponentListService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1107Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsNutrientComponentListService
   */
  private getBody(): PlessRequest {

    const params = {
      PCode: this.vo.pCode,
      ItemCode: this.vo.itemCode
    };

    if (this.vo.analysisSeqNo) {
      params['AnalysisSeqNo'] = this.vo.analysisSeqNo;
    }

    return new PlessRequest({
      parameter: params
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetGoodsNutrientComponentListService
   */
  execute(model: KYMW1107Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getGoodsNutrientComponentList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsNutrientComponentListService
   */
  success(data: any): void {
    // サーバからの結果を元に、商品栄養成分情報データを更新する
    this.model.setResultData(data);

    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
